// extracted by mini-css-extract-plugin
export var gif = "_ig-0";